const REASON_DATA = {
    absence_of_print: {
        label: 'Ausência de comprovante',
        description: 'O titular do cartão alega que não recebeu o comprovante desta transação.',
        instructions: 'Você pode refutar a contestação fornecendo uma cópia do recibo ou comprovante de entrega do produto ou serviço.',
    },
    absent_card_fraud: {
        label: 'Fraude sem presença do cartão',
        description: 'O titular do cartão alega que não autorizou esta transação.',
        instructions: 'Você pode refutar a contestação fornecendo evidências de que a compra foi autorizada, como logs de acesso, confirmação por e-mail ou comprovante de entrega.',
    },
    card_activated_phone_transaction: {
        label: 'Transação ativada por telefone',
        description: 'O titular do cartão alega que esta transação foi realizada por telefone sem sua autorização.',
        instructions: 'Você pode refutar a contestação fornecendo gravação da chamada ou confirmação de que o titular autorizou a transação.',
    },
    card_fraud: {
        label: 'Fraude com cartão',
        description: 'O titular do cartão alega que seu cartão foi utilizado de forma fraudulenta nesta transação.',
        instructions: 'Você pode refutar a contestação fornecendo evidências da autenticidade da transação, como dados de verificação ou logs de acesso.',
    },
    card_recovery_bulletin: {
        label: 'Cartão em lista de bloqueio',
        description: 'Este cartão estava listado como bloqueado no momento da transação.',
        instructions: 'Você pode refutar a contestação demonstrando que seguiu os procedimentos de segurança adequados ao aceitar o pagamento.',
    },
    commercial_disagreement: {
        label: 'Desacordo comercial',
        description: 'O titular do cartão discorda dos termos comerciais desta transação.',
        instructions: 'Você pode refutar a contestação fornecendo os termos de serviço aceitos pelo cliente e comprovantes da transação.',
    },
    copy_not_received: {
        label: 'Cópia não recebida',
        description: 'O titular do cartão alega que não recebeu a cópia solicitada desta transação.',
        instructions: 'Você pode refutar a contestação enviando a cópia solicitada ou comprovando que ela foi enviada anteriormente.',
    },
    credit_or_debit_presentation_error: {
        label: 'Erro de apresentação de crédito/débito',
        description: 'O titular do cartão alega que houve um erro na forma como o crédito ou débito foi apresentado.',
        instructions: 'Você pode refutar a contestação fornecendo o comprovante correto da transação e demonstrando que não houve erro de processamento.',
    },
    different_pay_method: {
        label: 'Forma de pagamento diferente',
        description: 'O titular do cartão alega que a forma de pagamento utilizada é diferente da acordada.',
        instructions: 'Você pode refutar a contestação fornecendo a confirmação do método de pagamento acordado e a autorização do titular.',
    },
    fraud: {
        label: 'Fraude',
        description: 'O titular do cartão alega que esta transação foi realizada de forma fraudulenta.',
        instructions: 'Você pode refutar a contestação fornecendo evidências da legitimidade da transação, como registros de autenticação e logs de acesso.',
    },
    incorrect_transaction_value: {
        label: 'Valor incorreto da transação',
        description: 'O titular do cartão alega que o valor cobrado é diferente do acordado.',
        instructions: 'Você pode refutar a contestação fornecendo o comprovante da transação com o valor correto e a confirmação do pedido.',
    },
    invalid_currency: {
        label: 'Moeda inválida',
        description: 'O titular do cartão alega que a moeda utilizada na transação é inválida ou diferente do acordado.',
        instructions: 'Você pode refutar a contestação demonstrando que a moeda foi acordada e autorizada pelo titular.',
    },
    invalid_data: {
        label: 'Dados inválidos',
        description: 'O titular do cartão alega que os dados desta transação são inválidos ou incorretos.',
        instructions: 'Você pode refutar a contestação fornecendo os dados corretos e a confirmação da transação.',
    },
    late_presentation: {
        label: 'Apresentação tardia',
        description: 'Esta transação foi apresentada para processamento fora do prazo permitido pela rede.',
        instructions: 'Você pode refutar a contestação demonstrando que a apresentação foi feita dentro do prazo regulamentar ou justificando o motivo do atraso.',
    },
    local_regulatory_or_legal_dispute: {
        label: 'Disputa regulatória ou legal',
        description: 'Esta contestação envolve uma disputa de natureza regulatória ou legal local.',
        instructions: 'Você pode refutar a contestação fornecendo documentação legal e comprovantes que demonstrem conformidade com as regulamentações aplicáveis.',
    },
    multiple_rocs: {
        label: 'Múltiplos registros de compra',
        description: 'O titular do cartão alega que foi cobrado múltiplas vezes pelo mesmo produto ou serviço.',
        instructions: 'Você pode refutar a contestação demonstrando que cada cobrança corresponde a uma transação distinta e legítima.',
    },
    original_credit_transaction_not_accepted: {
        label: 'Transação de crédito original não aceita',
        description: 'A transação de crédito original não foi aceita pelo titular do cartão.',
        instructions: 'Você pode refutar a contestação fornecendo evidências de que a transação foi devidamente autorizada e processada.',
    },
    other_absent_card_fraud: {
        label: 'Outra fraude sem presença do cartão',
        description: 'O titular do cartão alega que não autorizou esta transação realizada sem a presença física do cartão.',
        instructions: 'Você pode refutar a contestação fornecendo evidências de autenticação e autorização da transação.',
    },
    process_error: {
        label: 'Erro de processamento',
        description: 'Houve um erro no processamento desta transação.',
        instructions: 'Você pode refutar a contestação demonstrando que a transação foi processada corretamente e que o titular não sofreu prejuízo.',
    },
    received_copy_illegible_or_incomplete: {
        label: 'Cópia ilegível ou incompleta',
        description: 'O titular do cartão alega que a cópia recebida da transação está ilegível ou incompleta.',
        instructions: 'Você pode refutar a contestação enviando uma cópia legível e completa da transação.',
    },
    recurrence_canceled: {
        label: 'Recorrência cancelada',
        description: 'O titular do cartão alega que cancelou a cobrança recorrente antes desta transação ser processada.',
        instructions: 'Você pode refutar a contestação fornecendo a data do cancelamento e demonstrando que esta cobrança ocorreu antes da solicitação ou que os termos de cancelamento não foram respeitados.',
    },
    required_authorization_not_granted: {
        label: 'Autorização não concedida',
        description: 'Esta transação foi processada sem a devida autorização do titular do cartão.',
        instructions: 'Você pode refutar a contestação fornecendo o registro de autorização da transação ou demonstrando que a mesma foi devidamente autenticada.',
    },
    right_of_full_recourse_for_fraud: {
        label: 'Direito de regresso por fraude',
        description: 'O emissor do cartão está exercendo o direito de regresso total por suspeita de fraude nesta transação.',
        instructions: 'Você pode refutar a contestação fornecendo evidências detalhadas de que a transação foi legítima, autorizada e entregue conforme o acordado.',
    },
    sale_canceled: {
        label: 'Venda cancelada',
        description: 'O titular do cartão alega que a venda foi cancelada, mas o valor ainda foi debitado.',
        instructions: 'Você pode refutar a contestação fornecendo o comprovante de que o cancelamento não foi solicitado ou que o reembolso já foi devidamente processado.',
    },
    service_disagreement_or_defective_product: {
        label: 'Desacordo com serviço ou produto defeituoso',
        description: 'O titular do cartão alega que o serviço prestado está em desacordo com o contratado ou que o produto recebido é defeituoso.',
        instructions: 'Você pode refutar a contestação fornecendo comprovantes de que o produto ou serviço foi entregue em conformidade com o descrito e acordado.',
    },
    service_not_received: {
        label: 'Serviço não recebido',
        description: 'O titular do cartão alega que não recebeu o serviço contratado.',
        instructions: 'Você pode refutar a contestação fornecendo comprovantes de entrega ou registros de acesso ao serviço.',
    },
    split_sale: {
        label: 'Venda dividida',
        description: 'O titular do cartão alega que uma única venda foi dividida em múltiplas transações sem sua autorização.',
        instructions: 'Você pode refutar a contestação demonstrando que a divisão foi acordada ou que cada transação corresponde a um produto ou serviço distinto.',
    },
    transfers_of_diverse_responsibilities: {
        label: 'Transferência de responsabilidades',
        description: 'Esta contestação envolve uma disputa sobre a transferência de responsabilidades na transação.',
        instructions: 'Você pode refutar a contestação fornecendo documentação que comprove a distribuição correta de responsabilidades entre as partes.',
    },
    unqualified_car_rental_debit: {
        label: 'Débito não qualificado de aluguel de veículo',
        description: 'O titular do cartão contesta um débito relacionado a aluguel de veículo.',
        instructions: 'Você pode refutar a contestação fornecendo o contrato de aluguel assinado e os comprovantes de uso.',
    },
    usa_cardholder_dispute: {
        label: 'Disputa de titular dos EUA',
        description: 'O titular americano do cartão está contestando esta transação.',
        instructions: 'Você pode refutar a contestação fornecendo evidências da autorização e entrega do produto ou serviço.',
    },
    visa_fraud_monitoring_program: {
        label: 'Programa de monitoramento de fraude Visa',
        description: 'Esta transação foi identificada pelo programa de monitoramento de fraude da Visa.',
        instructions: 'Você pode refutar a contestação fornecendo evidências detalhadas da autenticidade e autorização da transação.',
    },
    warning_bulletin_file: {
        label: 'Arquivo de boletim de alerta',
        description: 'O cartão utilizado nesta transação consta em um boletim de alerta de segurança.',
        instructions: 'Você pode refutar a contestação demonstrando que não tinha conhecimento do alerta e que seguiu todos os procedimentos de segurança exigidos.',
    },
    fraudulent: {
        label: 'Fraude',
        description: 'O titular do cartão alega que esta transação é fraudulenta e que não a reconhece.',
        instructions: 'Você pode refutar a contestação fornecendo evidências de autenticação, como confirmação por e-mail, logs de acesso ou comprovante de entrega.',
    },
    duplicate: {
        label: 'Cobrança duplicada',
        description: 'O titular do cartão alega que foi cobrado mais de uma vez pelo mesmo produto ou serviço.',
        instructions: 'Você pode refutar a contestação demonstrando que as cobranças correspondem a transações distintas, ou processando o estorno da cobrança duplicada.',
    },
    credit_not_processed: {
        label: 'Crédito não processado',
        description: 'O titular do cartão alega que não recebeu o crédito ou reembolso prometido.',
        instructions: 'Você pode refutar a contestação demonstrando que o crédito foi devidamente processado, fornecendo o comprovante do reembolso.',
    },
    product_not_received: {
        label: 'Produto não recebido',
        description: 'O titular do cartão alega que não recebeu o produto adquirido.',
        instructions: 'Você pode refutar a contestação fornecendo o comprovante de entrega, código de rastreamento ou confirmação de acesso ao produto digital.',
    },
    product_unacceptable: {
        label: 'Produto inaceitável',
        description: 'O titular do cartão alega que o produto ou serviço estava defeituoso, danificado ou diferente da descrição.',
        instructions: 'Você pode refutar a contestação fornecendo comprovantes de que o produto foi entregue na condição esperada, ou aceitar imediatamente a contestação para reembolsar o titular do cartão e encerrar a disputa.',
    },
    subscription_canceled: {
        label: 'Assinatura cancelada',
        description: 'O titular do cartão alega que cancelou a assinatura antes desta cobrança ser processada.',
        instructions: 'Você pode refutar a contestação demonstrando que a cobrança ocorreu dentro do prazo vigente da assinatura ou que os termos de cancelamento não foram cumpridos.',
    },
    general: {
        label: 'Geral',
        description: 'O titular do cartão contestou esta transação.',
        instructions: 'Você pode refutar a contestação fornecendo todos os documentos e evidências que comprovem a legitimidade da transação.',
    },
};

const REASON_FALLBACK = {
    label: 'Motivo desconhecido',
    description: 'O titular do cartão contestou esta transação.',
    instructions: 'Você pode refutar a contestação fornecendo evidências que comprovem a legitimidade da transação realizada.',
};

export function getChargebackReason(reason) {
    return REASON_DATA[reason] || { ...REASON_FALLBACK, label: reason || REASON_FALLBACK.label };
}

export default REASON_DATA;
